import React, { Component, Fragment } from "react";
import DatePicker from "react-datepicker";
import { Button, OutlinedInput } from "@mui/material";
import { connect } from "react-redux";
import { withRouter } from "utilities/withRouter";
import { Tooltip } from "@mui/material";
import moment from "moment";
import { Icon } from "__ICON_REFERENCE__";
import { IconButton, InputAdornment } from "@mui/material";

import { Section } from "@sunwing/components";
import { getDeviationItinerary, updateDeviationItinerary } from "services/quote/quote.service";
import PageHeader from "components/common/pageHeader/pageHeader";
import ProductTypeIcon from "components/common/productTypeIcon/productTypeIcon";
import { CONFIGURATION } from "utilities/configuration";
import MarkAsComplete from "components/markAsComplete";

import "../viewQuoteItinerary/viewQuoteItinerary.scss";
import "./viewItineraryDeviation.scss";

class ViewItineraryDeviation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            isShowDelete: false,
            defaultData: {}
        };
    }

    componentDidMount() {
        this.getDeviationItinerary();
    }

    getDeviationItinerary = async () => {
        let { quoteNumber, itineraryID } = this.props.params;

        try {
            const response = await this.props.dispatch(getDeviationItinerary({ quoteNumber, itineraryID }));
            if (response?.payload?.data) {
                let { data, defaultData } = this.state;
                data = structuredClone(response.payload?.data);
                defaultData = structuredClone(response.payload?.data);
                this.setState({ data, defaultData });
            }
        }
        catch (error) {
            console.error("Error fetching quote itinerary:", error);
        }
    };

    saveItinerary() {
        let payload = this.state?.data;
        this.props
            .dispatch(updateDeviationItinerary(payload))
            .then((response) => {
                this.getDeviationItinerary();
            });

    }

    markAsCompleteItinerary() {
        let payload = this.state?.data;
        const { leadNumber, quoteNumber } = this.props.params;
        payload.markAsComplete = true;
        this.props
            .dispatch(updateDeviationItinerary(payload))
            .then((response) => {
                this.getDeviationItinerary();
                this.props.navigate("/lead/" + leadNumber + "/quote/" + quoteNumber);
            });

    }

    onCancel() {
        this.getDeviationItinerary();
    }

    setMarkAsComplete = (value) => {
        this.setState({
            isShowDelete: value
        });
    };

    isUpdated = () => {
        let { data, defaultData } = this.state;

        if (data !== null && defaultData && defaultData !== null) {
            if (JSON.stringify(data) !== (JSON.stringify(defaultData))) {
                return true;
            }
            else {
                return false;
            }
        }
        return false;

    };

    handleRemarks = (event, row, value) => {
        let { remarks } = this.state?.data;
        remarks[row][value] = event;
        this.setState({ remarks });
    };

    handleFlight = (event, row, value) => {
        let { data } = this.state;
        data["flights"][row][value] = event;
        this.setState({ data });        
    };

    handlePricingDescription = (event, row, value) => {
        let { data } = this.state;
        data["pricingDetails"][row][value] = event;
        this.setState({ data });

    };

    handleExpiryDate = (event) => {
        let { data } = this.state;
        data["expiryDate"] = event;
        this.setState({ data });
    };


    addButton = () => {
        this.setState({
            data: {
                ...this.state?.data,
                remarks: [...this.state?.data?.remarks, {}]
            }

        });
    };

    addButtonFlight = () => {
        this.setState({
            data: {
                ...this.state?.data,
                flights: [...this.state?.data?.flights, {}]
            }
        });
    };

    addButtonPricing = () => {
        this.setState({
            data: {
                ...this.state?.data,
                pricingDetails: [...this.state?.data?.pricingDetails, {}]
            }
        });
    };

    onClose = () => {
        const { leadNumber, quoteNumber } = this.props.params;
        this.props.navigate("/lead/" + leadNumber + "/quote/" + quoteNumber);
    };

    render() {

        let { option, quoteNumber, quoteDate, expiryDate, quoteBy, noOfAdults, noOfChildren, destinations, departures, products, rooms, itineraryNumber, remarks, flights, pricingDetails, historyLog, markAsComplete } = this.state.data;       
        let { isShowDelete } = this.state;
        
        let quoteItinerary = { data: this.state.data };
        let selectedDate = expiryDate ? new Date(expiryDate).getTime() + (new Date(expiryDate)?.getTimezoneOffset() * 60000) : null;

        return (
            <Fragment>
                <MarkAsComplete
                    isShow={isShowDelete}
                    data={{ quoteItinerary }}
                    handleMarkAsComplete={() => this.markAsCompleteItinerary()}
                    handleCancel={() => this.setMarkAsComplete(false)}
                />
                <div className="row margin-bottom-4x view-group-itinerary-container">
                    {
                        <div className="row">

                            <Section className="print-hide">
                                <div className="page-main-container margin-bottom-1x">
                                    <PageHeader />
                                </div>
                            </Section>

                            <Section className="print-hide">
                                <div className="row">
                                    <Button
                                        onClick={() => this.onClose()}
                                        data-testid="close-button"
                                        variant="text"
                                        className="pull-right"
                                    >
                                        <Icon
                                            name="close"
                                            className="cursor-pointer icon-16 margin-right"
                                        />
                                        {this.props.localize("qma-close")}
                                    </Button>
                                </div>

                            </Section>


                            <Section>
                                <div className="table itinerary-information-container">
                                    <div className="table-body">
                                        <div className="table-row first-row d-flex">
                                            <div className="table-column table-column-min font-bold">
                                                Option
                                            </div>
                                            <div className="table-column table-column-min">
                                                {option?.code}
                                            </div>
                                            <div className="table-column table-column-min">
                                                &nbsp;
                                            </div>
                                            <div className="table-column table-column-min font-bold">
                                                Quote number
                                            </div>
                                            <div className="table-column table-column-min">
                                                {quoteNumber}
                                            </div>
                                        </div>

                                        <div className="table-row first-row d-flex">
                                            <div className="table-column table-column-min font-bold">
                                                Itinerary number
                                            </div>
                                            <div className="table-column table-column-min">
                                                {itineraryNumber}
                                            </div>
                                            <div className="table-column table-column-min">
                                                &nbsp;
                                            </div>
                                            <div className="table-column table-column-min font-bold">
                                                Quote date
                                            </div>
                                            <div className="table-column table-column-min">
                                                {moment(quoteDate).format(CONFIGURATION.DATE_FORMAT)}
                                            </div>
                                        </div>

                                        <div className="table-row first-row d-flex">
                                            <div className="table-column table-column-min font-bold">
                                                Expiry date
                                            </div>

                                            <div className="table-column table-column-min">                                              
                                                <div className="row">
                                                    <DatePicker
                                                        showIcon
                                                        selected={selectedDate}
                                                        onChange={(date) => this.handleExpiryDate(date)}
                                                        disabled={markAsComplete}
                                                        dateFormat="dd MMM yyyy"
                                                        className="date-picker-itinerary"
                                                    />
                                                    <Icon name="calendar" className="itinerary-cal-icon" />
                                                </div>
                                            </div>


                                            <div className="table-column table-column-min">
                                                &nbsp;
                                            </div>
                                            <div className="table-column table-column-min font-bold">
                                                Quote by
                                            </div>
                                            <div className="table-column table-column-min">
                                                {quoteBy?.firstName === null ? "" : quoteBy?.firstName + " " + quoteBy?.lastName}
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="table itinerary-information-container">
                                    <div className="table-body">
                                        <div className="table-row d-flex">
                                            <div className="table-column table-column-min font-bold">
                                                <div className="d-flex view-itinerary-section-heading">
                                                    <Icon name="room-guests" className="font-14 font-orange margin-right" />Travellers
                                                </div>
                                            </div>
                                            <div className="table-column table-column-min font-bold">
                                                <div className="d-flex view-itinerary-section-heading">
                                                    <ProductTypeIcon productType="flight" className="font-orange"/>
                                                    Departure City
                                                </div>
                                            </div>

                                            <div className="table-column table-column-min font-bold">
                                                <div className="d-flex view-itinerary-section-heading">
                                                    <Icon name="map" className="font-orange margin-right"/>Destination
                                                </div>
                                            </div>
                                            <div className="table-column table-column-min font-bold">
                                                <div className="d-flex view-itinerary-section-heading">
                                                    <ProductTypeIcon productType="hotel" className="font-orange"/>
                                                    Hotel / Cruise
                                                </div>
                                            </div>
                                            <div className="table-column table-column-min font-bold">
                                                <div className="d-flex view-itinerary-section-heading">
                                                    <Icon name="accommodations" className="font-orange margin-right"/>Room / Cabin
                                                </div>
                                            </div>
                                        </div>

                                        
                                        <div className="table-row d-flex">
                                            <div className="table-column table-column-min">
                                                {noOfAdults + " Adults"}
                                                <br />
                                                {noOfChildren + " Children"}
                                            </div>
                                            <div className="table-column table-column-min">
                                                {departures?.map(departure => {
                                                    return (<div>
                                                        {"(" + departure?.code + ") " + departure?.name}
                                                    </div>);
                                                })
                                                }
                                            </div>
                                            <div className="table-column table-column-min">

                                                {destinations?.map(destination => {
                                                    return (<div>
                                                        {"(" + destination?.code + ") " + destination?.name}
                                                    </div>);
                                                })
                                                }
                                            </div>
                                            <div className="table-column table-column-min text-ellipsis">

                                                {products?.map(product => {
                                                    return (   
                                                        <Tooltip title={product?.name} placement="top-start">
                                                            <div className="room-name text-ellipsis">
                                                                {product?.name}
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                })
                                                }
                                            </div>
                                            <div className="table-column table-column-min text-ellipsis">

                                                {rooms?.map(room => {
                                                    return (
                                                        <Tooltip title={room?.name} placement="top-start">
                                                            <div className="room-name text-ellipsis">
                                                                {room?.name}
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Section>

                            <Section>
                                <div className="d-flex margin-top-3x margin-bottom-1x font-bold">
                                    <Icon name="price--n font-orange margin-right" />Deviation remarks
                                </div>

                                <div>
                                    Text box has capacity of 2500 characters only. Click “+” to add more remarks. <br /> Tip: Keep phrases as short as possible.
                                </div>

                                <div className="row font-16 margin-top">
                                    <div className="row">
                                        {remarks?.map((item, index) => {
                                            return (<div>
                                                <div className="deviation-col">
                                                    <textarea className="terms-condition-container"
                                                        fullWidth={true}
                                                        maxLength = {2500}
                                                        rows={5}
                                                        name="deviation"
                                                        disabled={markAsComplete}
                                                        id={index}
                                                        value={item?.remarks}
                                                        onChange={(event) => {
                                                            this.handleRemarks(event?.target?.value, index, "remarks");
                                                        }}
                                                        aria-describedby="outlined-deviation"
                                                    />

                                                </div>
                                                <div className="row text-align-right font-14 font-light-grey margin-top">
                                                    {item?.remarks?.length === undefined ? 0 : item?.remarks?.length}/2500
                                                </div>
                                            </div>);
                                        })}
                                        {!markAsComplete ? 
                                            <div className="row margin-top-1x">
                                                <div className="pull-right">
                                                    <Button
                                                        onClick={() => this.addButton()}
                                                        className="add-button"
                                                        disabled={!remarks || (!remarks[remarks?.length - 1]?.remarks ||
                                                            remarks[remarks?.length - 1]?.remarks === null ||
                                                            remarks[remarks?.length - 1]?.remarks?.length < 1)}
                                                        variant="outlined">
                                                        <Icon name="plus--n" />
                                                    </Button>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                            </Section>

                            <Section>
                                <div className="d-flex margin-top-3x margin-bottom-1x font-bold">
                                    <ProductTypeIcon productType="flight" className="font-orange"/>Flights
                                </div>

                                <div className="row font-16 margin-top">
                                    <div className="row">
                                        {flights?.map((flight, index) => {
                                            return (
                                                <div className="deviation-flight-col">
                                                    <div className="row">
                                                        <div className="col-half">
                                                            <div>Flights outbound</div>    
                                                            <OutlinedInput
                                                                fullWidth={true}
                                                                className="deviation-flight-input"
                                                                name="outbound"
                                                                disabled={markAsComplete}
                                                                id="outlined-group-name"
                                                                value={flight?.inbound ?? ""}
                                                                aria-describedby="outlined-deviation"
                                                                onChange={(event) => {
                                                                    this.handleFlight(event?.target?.value, index, "inbound");
                                                                }}
                                                            />                                                        </div>
                                                        <div className="col-half">
                                                            <div>Flights inbound</div>
                                                            <OutlinedInput
                                                                fullWidth={true}
                                                                className="deviation-flight-input"
                                                                name="inbound"
                                                                disabled={markAsComplete}
                                                                id="outlined-group-name"
                                                                value={flight?.outbound ?? ""}
                                                                aria-describedby="outlined-deviation"
                                                                onChange={(event) => {
                                                                    this.handleFlight(event?.target?.value, index, "outbound");
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>);
                                        })}

                                        <div className="deviation-action-col">
                                            {!markAsComplete ? 
                                                <div className="row">
                                                    <div>&nbsp;</div>
                                                    <Button
                                                        onClick={() => this.addButtonFlight()}
                                                        className="add-button"                                                                                               
                                                        variant="outlined">
                                                        <Icon name="plus--n" />
                                                    </Button>
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>

                            </Section>

                            <Section>
                                <div className="d-flex margin-top-3x margin-bottom-1x font-bold">
                                    <Icon name="price--n font-orange margin-right" />Pricing per person
                                </div>
                                <div className="row">
                                    {pricingDetails?.map((pricing, index) => {
                                        return (
                                            <div className="row">
                                                <div className="itinerary-pricing-col">
                                                    <OutlinedInput
                                                        fullWidth
                                                        name="pricing"
                                                        disabled={markAsComplete}
                                                        id="outlined-pricing"
                                                        className="container-bg"
                                                        placeholder="00.00"
                                                        inputProps={{ maxLength: 10 }}
                                                        startAdornment={
                                                            <InputAdornment position="start">
                                                                <IconButton>
                                                                    <Icon name="price--n" />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                        endAdornment={<div className="price-cad">CAD</div>}
                                                        value={pricing?.price}
                                                        aria-describedby="outlined-pricing"
                                                        onChange={(event) => {
                                                            const regex = /^[0-9\b]+$/;
                                                            if (event.target.value === "" || regex.test(event.target.value)) {
                                                                let value = event.target.value === "" ? null : parseInt(event.target.value, 10);
                                                                this.handlePricingDescription(value, index, "price");
                                                            }
                                                        }}

                                                    />

                                                </div>
                                                <div className="itinerary-pricing-col-desc">
                                                    <OutlinedInput
                                                        fullWidth={true}
                                                        name="description"
                                                        disabled={markAsComplete}
                                                        id="outlined-description"
                                                        className="container-bg"
                                                        inputProps={{ maxLength: 70 }}
                                                        placeholder="Price description"
                                                        value={pricing?.priceDescription}
                                                        aria-describedby="outlined-description"
                                                        onChange={(event) => {
                                                            this.handlePricingDescription(event?.target?.value, index, "priceDescription");
                                                        }}
                                                    />
                                                </div>

                                                <div className="row text-align-right font-14 font-light-grey">
                                                    {pricing?.priceDescription?.length === undefined ? 0 : pricing?.priceDescription?.length}/70
                                                </div>
                                            </div>);
                                    })}
                                    <div className="row">
                                        <div className="deviation-action-col">
                                            {!markAsComplete ? <Button
                                                onClick={() => this.addButtonPricing()}
                                                className="add-button"                                            
                                                variant="outlined">
                                                <Icon name="plus--n" />
                                            </Button> : ""
                                            }
                                        </div>
                                    </div>
                                </div>



                            </Section>

                            <Section>
                                {!markAsComplete ?
                                    <div className="row margin-top-3x margin-bottom-1x">
                                        <div className="pull-right">
                                            <Button className="btn-green" variant="contained" disabled={false} onClick={() => this.setMarkAsComplete(true)}>
                                                Mark as complete
                                            </Button>
                                        </div>

                                        <div className="pull-right margin-right-1x">
                                            <Button variant="contained" disabled={!this.isUpdated()} onClick={() => this.saveItinerary()}>Save</Button>
                                        </div>

                                        {this.isUpdated() ? <div className="pull-right margin-right-1x">
                                            <Button variant="outlined" onClick={() => this.onCancel()}>Cancel</Button>
                                        </div> : ""}
                                    </div> : ""
                                }
                            </Section>

                            {this.state?.data?.historyLog?.length > 0 ?<Section>
                                <div className="row margin-top-2x margin-bottom-1x">
                                    <h3 className="font-bold">History Log</h3>
                                </div>

                                <div className="table">
                                    <div className="table-head">
                                        <div className="table-row font-bold">
                                            <div className="table-column view-quote-itinerary-updated-by">
                                                Updated by
                                            </div>
                                            <div className="table-column view-quote-itinerary-updated-on">
                                                Updated on
                                            </div>
                                            <div className="table-column view-quote-itinerary-log">Log</div>
                                        </div>
                                    </div>
                                    <div className="table-body">
                                        {historyLog?.map((history, historyIndex) => (
                                            <div key={historyIndex} className="table-row">
                                                <div className="table-column view-quote-itinerary-updated-by">
                                                    {history.updatedBy}
                                                </div>
                                                <div className="table-column view-quote-itinerary-updated-on">
                                                    {moment(history.updatedOn).format(
                                                        CONFIGURATION.DATE_FORMAT_TIME
                                                    )}
                                                </div>
                                                <div className="table-column view-quote-itinerary-log">
                                                    {history?.log}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Section> : ""}
                        </div>
                    }

                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    quoteItinerary: state.quoteItinerary
});

export default connect(mapStateToProps)(withRouter(ViewItineraryDeviation));
